import { components } from "@/api-schema";
import { Action, RelocationOrderStatus } from "@/api-schema-enums";
import type { AppAbility } from "@/casl-provider";
import { isRelocationOrderTerminalStatus } from "@/common/helpers/relocation-order-terminal-status";
import { subject } from "@casl/ability";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function canCancelRelocationOrder(ability: Pick<AppAbility, "can">, relocationOrder: RelocationOrder): boolean {
  if (
    isRelocationOrderTerminalStatus(relocationOrder.status) ||
    relocationOrder.status === RelocationOrderStatus.TransportCompanyInTransit
  ) {
    return false;
  }

  return ability.can(Action.Delete, subject("RelocationOrder", { ...relocationOrder }));
}
